export default __webpack_public_path__ + "static/media/Profile_icon_new.407c83a7.svg";